/**
 * User: gedas
 * Date: 08/12/14
 * Time: 5:15 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */
'use strict';

var userHelper = (module.exports = {});
var User = require('../../models/User');
var authModalLoader = require('dibs-buyer-layout/src/utils/AuthModalLoader').default;

/**
 * checkLogin allows for updating page content for logged-in specific content without a refresh
 * @param ga - {object} - tracking data
 * @return {object}
 */
userHelper.checkLogin = function(ga, flow, action, additionalProps, email) {
    if (!User.loggedIn()) {
        return authModalLoader.show({
            action:
                action ||
                (User.everLoggedIn()
                    ? authModalLoader.constants.LOGIN
                    : authModalLoader.constants.REGISTER),
            flow: flow,
            ga: ga,
            additionalProps: additionalProps,
            email: email,
        });
    }
    return User.load();
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/commonjs/userHelper.js
// module id = 239
// module chunks = 62